<template>
  <svg
    v-if="!checked"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 28 28"
  >
    <path
      fill="#D6D7D9"
      fill-rule="evenodd"
      d="M15.265 3.415c-.51-1.053-2.02-1.053-2.53 0l-2.464 5.094c-.205.422-.61.714-1.078.777l-5.642.753c-1.166.156-1.633 1.582-.782 2.388l4.119 3.902c.341.323.496.796.411 1.257l-1.021 5.56c-.212 1.149 1.01 2.03 2.046 1.476l5.01-2.683a1.412 1.412 0 0 1 1.332 0l5.01 2.683c1.036.554 2.258-.327 2.047-1.476l-1.022-5.56c-.085-.461.07-.934.412-1.257l4.118-3.902c.851-.806.384-2.232-.782-2.388l-5.642-.753a1.402 1.402 0 0 1-1.077-.777l-2.465-5.094Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 28 28"
  >
    <path
      fill="#FF7D00"
      fill-rule="evenodd"
      d="M15.265 3.415c-.51-1.053-2.02-1.053-2.53 0l-2.464 5.094c-.205.422-.61.714-1.078.777l-5.642.753c-1.166.156-1.633 1.582-.782 2.388l4.119 3.902c.341.323.496.796.411 1.257l-1.021 5.56c-.212 1.149 1.01 2.03 2.046 1.476l5.01-2.683a1.412 1.412 0 0 1 1.332 0l5.01 2.683c1.036.554 2.258-.327 2.047-1.476l-1.022-5.56c-.085-.461.07-.934.412-1.257l4.118-3.902c.851-.806.384-2.232-.782-2.388l-5.642-.753a1.402 1.402 0 0 1-1.077-.777l-2.465-5.094Z"
      clip-rule="evenodd"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "StarIcon",
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style></style>
